import React from 'react';
import { Building2 } from 'lucide-react';

export function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-slate-50 bg-mesh flex flex-col items-center justify-center">
      <div className="relative flex flex-col items-center">
        <div className="relative">
          <div className="absolute inset-0 rounded-2xl bg-primary-500/20 blur-xl animate-pulse-soft" />
          <div className="relative w-16 h-16 rounded-2xl bg-gradient-to-br from-primary-600 to-primary-700 flex items-center justify-center shadow-xl shadow-primary-600/25 animate-float">
            <Building2 className="h-8 w-8 text-white" />
          </div>
        </div>
        <div className="mt-8 flex gap-1.5">
          <div className="w-1.5 h-1.5 rounded-full bg-primary-400 animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-1.5 h-1.5 rounded-full bg-primary-600 animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
        <p className="mt-5 text-xs font-medium text-slate-400 tracking-wider uppercase">
          Chargement
        </p>
      </div>
    </div>
  );
}
